import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";

import { AuthProvider } from "./context/AuthContext";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


if (localStorage.getItem("proceed_to_payout") !== "true") {
  localStorage.setItem("proceed_to_payout", "false");
}

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);